import {
  CCol,
  CFormInput,
  CFormLabel,
  CLoadingButton,
  CRow,
  CSpinner,
} from "@coreui/react-pro";
import CurrentTime from "./CurrentTime";
import axios from "../../../shared/config/axios-interceptor";
import { useEffect, useRef, useState } from "react";
import { useRouter } from "@/shared/utils/hooks/useRouter";
import ListGiaPC from "./components/ListGiaPC";
import ListGiaPCBottom from "./components/ListGiaPCBottom";
import { formatVND } from "@/shared/utils/ultils";
import CountDownPc from "./components/CountDownPc";
import { ToastError, ToastSuccess } from "@/components/shared/toast/Toast";
import RenderAutoDatPc from "./RenderAutoDatPc";

import bibg from "../../../assets/img/bi.webp";
import ListRoom from "./components/ListRoom";
import SelectMarket from "./components/SelectMarket";
import { useSearchParams } from "react-router-dom";
import ThiTruong from "./components/ThiTruong";
import RenderChiTietHangHoa from "./components/RenderChiTietHangHoa";
import LichSuPhien from "./components/LichSuPhien";

const GamePc = () => {
  const { params } = useRouter();
  const [searchParams] = useSearchParams();
  const marketId = searchParams.get("market");

  const [user, setUser] = useState<any>(null);
  const [game, setGame] = useState(null);
  const [market, setMarket] = useState<any>(null);
  const [idMarket, setIdMarket] = useState(1);

  const [phien, setPhien] = useState<any>(null);
  const [config, setConfig] = useState<any>(null);
  const [ketQuaKyTruoc, setKetQuaKyTruoc] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [money, setMoney] = useState("");
  const [load, setLoad] = useState(false);
  const [laiLo, setLaiLo] = useState<any>(null);
  const [lichSu, setLichSu] = useState<any[]>([]);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const getProfile = async () => {
    try {
      if (params?.userId) {
        const res = await axios.get("/user/" + params?.userId);
        setUser(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getMarket = async () => {
    try {
      const res = await axios.get(
        "/market/" + (idMarket ? idMarket : marketId ?? 1)
      );
      setMarket(res?.data);
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    getMarket();
  }, [idMarket, marketId]);

  const getConfig = async () => {
    try {
      const res = await axios.get("/config/1");
      setConfig(res?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getGame = async () => {
    try {
      if (params?.id) {
        const res = await axios.get("/game/" + params?.id);
        setGame(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getPhien = async () => {
    try {
      const response = await axios.get("/draws/get-current/" + params?.id);
      setPhien(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getKetQuaKyTruoc = async () => {
    try {
      const response = await axios.get(
        "/draws/get-result-ket-qua-ky-truoc/" + params?.id
      );
      setKetQuaKyTruoc(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getLaiLo = async () => {
    try {
      if (params?.userId) {
        const response = await axios.get("/history/lai-lo/" + params?.userId);
        setLaiLo(response.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getLichSuDatCuoc = async () => {
    try {
      if (params?.userId) {
        const response = await axios.get(
          "/history?sortBy=id&sortOrder=desc&userId=" + params?.userId
        );
        setLichSu(response?.data?.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getConfig();
    getProfile();
    getGame();
    getPhien();
    getKetQuaKyTruoc();
    getLaiLo();
    getLichSuDatCuoc();
  }, [load]);

  const listCuoc = [
    { name: "LONG", rate: config?.content1 },
    { name: "SHORT", rate: config?.content1 },
    { name: "SINGLE", rate: config?.content1 },
    { name: "DOUBLE", rate: config?.content1 },
    { name: "LS", rate: config?.content2 },
    { name: "SS", rate: config?.content2 },
    { name: "LD", rate: config?.content2 },
    { name: "SD", rate: config?.content2 },
  ];

  const [cuoc, setCuoc] = useState<any>(null);

  if (!params?.userId || !user || !game)
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            background: "hsl(222.22, 65.85%, 8.04%)",
          }}
        >
          <div className="text-center">
            <p style={{ color: "#fff" }}>Đang vào sảnh...</p>
            <CSpinner color="light" variant="grow" />
          </div>
        </div>
      </>
    );

  const onSubmit = async () => {
    if (!money || Number(money) <= 0 || isNaN(Number(money))) {
      ToastError("Số tiền phải lớn hơn 0");
      return;
    }
    try {
      setLoading(true);
      const res = await axios.post("/history", {
        drawId: phien?.id,
        money,
        userId: params?.userId,
        voted: cuoc?.name,
        rate: cuoc?.rate,
      });

      setLoading(false);
      setMoney("");
      setCuoc(null);
      ToastSuccess("Đặt chip thành công!");
      getProfile();
      getLaiLo();
      getLichSuDatCuoc();
      inputRef?.current?.focus();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  let listHangHoa = [];
  if (config?.content10) {
    listHangHoa = JSON.parse(config?.content10 ?? "");
  }

  return (
    <>
      <div className="page-game-pc p-3">
        <CRow className="g-3">
          <CCol xs={12}>
            <ListGiaPC />
          </CCol>
          <CCol xs={3}>
            <div className="d-flex flex-column h-100">
              <ListRoom user={user} config={config} />
              <ThiTruong setIdMarket={setIdMarket} config={config} />
            </div>
          </CCol>
          <CCol xs={9}>
            <div>
              <CRow className="g-3">
                <CCol md={8}>
                  <div
                    className="p-3 h-100"
                    style={{ minHeight: 300, background: "hsl(223 64% 8%)" }}
                  >
                    <div className="d-flex justify-content-between">
                      <RenderChiTietHangHoa market={market} />

                      <div className="d-flex gap-4 align-items-center">
                        <div style={{ fontSize: 16 }}>
                          <span style={{ opacity: 0.7 }}>Lượt tham gia:</span>{" "}
                          {laiLo?.moneyTotal}
                        </div>
                        <div style={{ fontSize: 16 }}>
                          <span style={{ opacity: 0.7 }}>Biến động:</span>{" "}
                          <span
                            style={{
                              color:
                                laiLo?.addMoneyTotal == 0
                                  ? ""
                                  : laiLo?.addMoneyTotal > 0
                                  ? "rgb(53, 173, 122)"
                                  : "rgb(220, 56, 72)",
                            }}
                          >
                            {laiLo?.addMoneyTotal == 0
                              ? ""
                              : laiLo?.addMoneyTotal > 0
                              ? "+"
                              : "-"}
                            {formatVND(laiLo?.addMoneyTotal)}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      className="d-flex gap-2 justify-content-between mb-2 mt-3 align-items-center mb-3"
                      style={{ width: "90%", margin: "0 auto" }}
                    >
                      <h6
                        className="mb-0 w-100 text-center"
                        style={{ fontSize: 16 }}
                      >
                        Vòng: {ketQuaKyTruoc?.id}
                      </h6>
                      <div className="w-100 text-center d-flex justify-content-center">
                        <CountDownPc
                          phien={phien}
                          load={load}
                          setLoad={setLoad}
                        />
                      </div>
                      <h6
                        className="mb-0 w-100 text-center"
                        style={{ fontSize: 16 }}
                      >
                        Vòng lệnh sau: {phien?.id}
                      </h6>
                    </div>

                    <div className="d-flex flex-column gap-2 justify-content-center align-items-center mb-4">
                      {/* <h6 className="mb-3">Kết quả {ketQuaKyTruoc?.id}</h6> */}
                      <div className="d-flex align-items-center">
                        <div
                          style={{
                            position: "relative",
                            color: "#000",
                            fontWeight: "bold",
                            fontSize: 23,
                            width: 90,
                            height: 90,
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexShrink: 0,
                          }}
                        >
                          <div
                            className="position-relative"
                            style={{ zIndex: 2 }}
                          >
                            {ketQuaKyTruoc?.ball1}
                          </div>
                          <img
                            style={{
                              zIndex: 1,
                              position: "absolute",
                              top: 0,
                              right: 0,
                              bottom: 0,
                              left: 0,
                              width: "100%",
                              textAlign: "center",
                            }}
                            src={bibg}
                          />
                        </div>

                        <div
                          style={{
                            fontSize: 30,
                            fontWeight: 700,
                            color: "rgb(255, 0, 0)",
                          }}
                        >
                          +
                        </div>

                        <div
                          style={{
                            position: "relative",
                            color: "#000",
                            fontWeight: "bold",
                            fontSize: 23,
                            width: 90,
                            height: 90,
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexShrink: 0,
                          }}
                        >
                          <div
                            className="position-relative"
                            style={{ zIndex: 2 }}
                          >
                            {ketQuaKyTruoc?.ball2}
                          </div>
                          <img
                            style={{
                              zIndex: 1,
                              position: "absolute",
                              top: 0,
                              right: 0,
                              bottom: 0,
                              left: 0,
                              width: "100%",
                              textAlign: "center",
                            }}
                            src={bibg}
                          />
                        </div>

                        <div
                          style={{
                            fontSize: 30,
                            fontWeight: 700,
                            color: "rgb(255, 0, 0)",
                          }}
                        >
                          +
                        </div>

                        <div
                          style={{
                            position: "relative",
                            color: "#000",
                            fontWeight: "bold",
                            fontSize: 23,
                            width: 90,
                            height: 90,
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexShrink: 0,
                          }}
                        >
                          <div
                            className="position-relative"
                            style={{ zIndex: 2 }}
                          >
                            {ketQuaKyTruoc?.ball3}
                          </div>
                          <img
                            style={{
                              zIndex: 1,
                              position: "absolute",
                              top: 0,
                              right: 0,
                              bottom: 0,
                              left: 0,
                              width: "100%",
                              textAlign: "center",
                            }}
                            src={bibg}
                          />
                        </div>

                        <div
                          style={{
                            fontSize: 30,
                            fontWeight: 700,
                            color: "rgb(255, 0, 0)",
                          }}
                        >
                          =
                        </div>

                        <div
                          style={{
                            position: "relative",
                            color: "#000",
                            fontWeight: "bold",
                            fontSize: 23,
                            width: 90,
                            height: 90,
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexShrink: 0,
                          }}
                        >
                          <div
                            className="position-relative"
                            style={{ zIndex: 2 }}
                          >
                            {ketQuaKyTruoc?.ball1 +
                              ketQuaKyTruoc?.ball2 +
                              ketQuaKyTruoc?.ball3}
                          </div>
                          <img
                            style={{
                              zIndex: 1,
                              position: "absolute",
                              top: 0,
                              right: 0,
                              bottom: 0,
                              left: 0,
                              width: "100%",
                              textAlign: "center",
                            }}
                            src={bibg}
                          />
                        </div>

                        <div
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: "rgb(255, 0, 0)",
                          }}
                        >
                          {ketQuaKyTruoc?.ball1 +
                            ketQuaKyTruoc?.ball2 +
                            ketQuaKyTruoc?.ball3 >=
                          10
                            ? "LONG, DOUBLE"
                            : "SHORT, SINGLE"}
                        </div>
                      </div>
                    </div>

                    <RenderAutoDatPc phien={phien} />
                  </div>
                </CCol>
                <CCol md={4}>
                  <div>
                    <div
                      className="p-3 py-2 rounded-2"
                      style={{
                        background: "#d1ffd0",
                        color: "#000",
                        fontWeight: "bold",
                      }}
                    >
                      <div>
                        <div className="d-flex gap-2 align-items-center">
                          <img
                            style={{ width: 35 }}
                            src="https://faofood.com/assets/templates/basic/images/thumbs/d-1.png"
                          />
                          <div className="text-center">{user?.username}</div>
                        </div>
                        <div className="my-2">
                          {formatVND(user?.balance ?? 0)}
                        </div>
                      </div>
                    </div>

                    <SelectMarket
                      setIdMarket={setIdMarket}
                      idMarket={idMarket ? idMarket : Number(marketId) ?? 1}
                    />
                    <CurrentTime />

                    <div>
                      <CRow className="g-2">
                        {listCuoc.map((item, index) => {
                          return (
                            <CCol
                              xs={index > 5 ? 6 : 4}
                              key={index}
                              onClick={() => setCuoc(item)}
                            >
                              <div
                                className="rounded-2 text-center cursor-pointer"
                                style={{
                                  background:
                                    item?.name == cuoc?.name
                                      ? "hsl(49 92% 54%)"
                                      : "rgb(7, 15, 33)",
                                  paddingTop: 9,
                                  paddingBottom: 9,
                                  color:
                                    item?.name == cuoc?.name ? "#000" : "#fff",
                                }}
                              >
                                <div className="mb-1">{item?.name}</div>
                                <div style={{ fontSize: 13, opacity: 0.7 }}>
                                  {item?.rate}
                                </div>
                              </div>
                            </CCol>
                          );
                        })}
                      </CRow>
                    </div>

                    <div className="my-3">
                      <CFormLabel style={{ color: "#fff", fontSize: 14 }}>
                        Khối lượng chip
                      </CFormLabel>
                      <CFormInput
                        ref={inputRef}
                        placeholder="Nhập chip"
                        type="text"
                        style={{
                          background: "rgb(7, 15, 33)",
                          color: "#fff",
                          border: "none",
                          height: 50,
                          boxShadow: "none",
                        }}
                        value={money}
                        onChange={(e) => setMoney(e.target.value)}
                      />
                    </div>

                    <div>
                      <CLoadingButton
                        onClick={onSubmit}
                        disabled={loading || cuoc === null}
                        loading={loading}
                        className="w-100"
                        style={{
                          background: "rgb(246, 206, 30)",
                          color: "#fff",
                          height: 50,
                          fontWeight: "bold",
                        }}
                      >
                        XÁC NHẬN ĐẶT CHIP
                      </CLoadingButton>
                    </div>
                  </div>
                </CCol>

                <CCol xs={12}>
                  <div className="mb-3">
                    <ListGiaPCBottom />
                  </div>
                </CCol>

                <CCol xs={12}>
                  <div>
                    <CRow>
                      <CCol xs={8}>
                        <div className="pb-2">
                          <h6 className="mb-3">Lịch sử</h6>
                          <div style={{ height: 350, overflowY: "auto" }}>
                            {lichSu?.map((item, index) => {
                              return (
                                <div
                                  key={index}
                                  className="d-flex py-3"
                                  style={{
                                    borderTop: "1px solid rgb(95, 95, 95)",
                                    color: !item?.addMoney
                                      ? "rgb(246, 206, 30)"
                                      : item?.addMoney > 0
                                      ? "rgb(53, 173, 122)"
                                      : "rgb(255, 92, 81)",
                                  }}
                                >
                                  <div
                                    className="w-100"
                                    style={{ fontSize: 14 }}
                                  >
                                    {item?.drawId}
                                  </div>
                                  <div
                                    className="w-100"
                                    style={{ fontSize: 14 }}
                                  >
                                    {formatVND(item?.money)}
                                  </div>
                                  <div
                                    className="w-100"
                                    style={{ fontSize: 14 }}
                                  >
                                    {item?.voted} - {item?.rate}
                                  </div>
                                  {/* <div className="w-100" style={{ fontSize: 14 }}>
                                  {!item?.addMoney ? (
                                    <span style={{ color: "rgb(246, 206, 30)" }}>
                                      Chờ kết quả
                                    </span>
                                  ) : item?.addMoney > 0 ? (
                                    <span style={{ color: "rgb(53, 173, 122)" }}>
                                      Thắng
                                    </span>
                                  ) : (
                                    <span style={{ color: "rgb(255, 92, 81)" }}>
                                      Thua
                                    </span>
                                  )}
                                </div> */}
                                </div>
                              );
                            })}

                            {lichSu?.length == 0 && (
                              <div className="text-center mt-5" style={{ opacity: 0.7 }}>
                                Chưa có lịch sử
                              </div>
                            )}
                          </div>
                        </div>
                      </CCol>
                      <CCol xs={4}>
                        <LichSuPhien gameId={params?.id} load={load} />
                      </CCol>
                    </CRow>
                  </div>
                </CCol>
              </CRow>
            </div>
          </CCol>
        </CRow>
      </div>
      <div
        className="py-5 text-center"
        style={{ background: "#070f22", color: "#fff", fontSize: 14 }}
      >
        <p className="mb-0">
          ©2025{" "}
          <span style={{ color: "hsl(49 92% 54%)" }}>
            Tập Đoàn Lương Thực Thế Giới FAO
          </span>
          . Mọi quyền được bảo lưu.
        </p>
      </div>
    </>
  );
};

export default GamePc;
